import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.00005 1.77777C4.56539 1.77777 1.77783 4.56533 1.77783 7.99999C1.77783 11.4347 4.56539 14.2222 8.00005 14.2222C11.4347 14.2222 14.2223 11.4347 14.2223 7.99999C14.2223 4.56533 11.4347 1.77777 8.00005 1.77777ZM8.62228 11.1111H7.37783V9.86666H8.62228V11.1111ZM8.62228 8.62222H7.37783V4.88888H8.62228V8.62222Z",
		fill: "#EE3C15"
	})]
});
export default SvgWarning;
